import { createSlice } from '@reduxjs/toolkit';
import { NotificationItem } from '../types';
import {
  getNotification,
  markAllReadNotification,
  markReadNotification,
} from '../actions';

export interface NotificationState {
  notificationList: {
    data: NotificationItem[];
    totalUnread: number;
    totalDocs: number;
  };
  loading: boolean;
}

const initialState: NotificationState = {
  notificationList: {
    data: [],
    totalUnread: 0,
    totalDocs: 0,
  },
  loading: false,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    onReceiveNewNotification: (state, action) => {
      const newNoti = action?.payload || {};
      // Prevent duplicates from socket/API overlap
      const exists = state.notificationList.data.some(
        (item) => item.id === newNoti.id,
      );
      if (!exists) {
        state.notificationList.data = [
          newNoti,
          ...state.notificationList.data,
        ];
        state.notificationList.totalUnread =
          (state.notificationList.totalUnread || 0) + 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotification.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNotification.fulfilled, (state, action) => {
        state.notificationList = action.payload;
        state.loading = false;
      })
      .addCase(getNotification.rejected, (state) => {
        state.loading = false;
      })
      .addCase(markReadNotification.fulfilled, (state, action) => {
        const { id } = action.payload;
        const item = state.notificationList.data.find(
          (item) => item.id === id,
        );
        if (item && !item.isRead) {
          item.isRead = true;
          state.notificationList.totalUnread = Math.max(
            0,
            state.notificationList.totalUnread - 1,
          );
        }
      })
      .addCase(markAllReadNotification.fulfilled, (state) => {
        state.notificationList.data = state.notificationList.data.map(
          (item) => ({ ...item, isRead: true }),
        );
        state.notificationList.totalUnread = 0;
      });
  },
});

export const notificationReducer = notificationSlice.reducer;
export const notificationActions = {
  ...notificationSlice.actions,
  getNotification,
  markAllReadNotification,
  markReadNotification,
};
